import PropTypes from "prop-types";


export let FranchisePropTypes = PropTypes.shape({
  franchiseName: PropTypes.string
})